/**
 * ****************************************************************************
 * @description     :   Main store to control state and data for all app
 * @created at      :   2024/05/22
 * @created by      :   ANS903 – phuongdt@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import libraries
 */
import { createStore } from 'vuex';

/**
 * Import store of modules
 */
import AppStore from './app';

/**
 * Import store of modules report
 */

/**
 * Create main store
 */
export default createStore({
    modules: {
        app: AppStore
    }
});
